import { render } from "./ViewModalsComponent.vue?vue&type=template&id=533b10db"
import script from "./ViewModalsComponent.vue?vue&type=script&lang=js"
export * from "./ViewModalsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__